import { render, staticRenderFns } from "./UserDataEdition.vue?vue&type=template&id=6a1e63e8&"
import script from "./UserDataEdition.vue?vue&type=script&lang=js&"
export * from "./UserDataEdition.vue?vue&type=script&lang=js&"
import style0 from "./UserDataEdition.vue?vue&type=style&index=0&id=6a1e63e8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports